const products = [
  {
    name: "FUSA VPN",
    tagline: "Private. Fast. Secure.",
    description:
      "Military-grade encryption for your iOS device. FUSA VPN shields your browsing, protects sensitive data on public Wi-Fi, and keeps your online identity private — all with zero-log policy.",
    badge: "Privacy & Security",
    color: "from-emerald-50 to-teal-50",
    accent: "bg-emerald-100",
    accentText: "text-emerald-700",
    icon: "ri-shield-keyhole-line",
    iconColor: "text-emerald-600",
    image: "https://public.readdy.ai/ai/img_res/7623f436eb7f07bc2b533e5c1e22ef96.jpg",
    highlights: ["Zero-Log Policy", "256-bit Encryption", "Global Server Network"],
  },
  {
    name: "FUSA Cleaner",
    tagline: "Optimized. Organized. Faster.",
    description:
      "Reclaim storage and boost performance on your iPhone or iPad. FUSA Cleaner intelligently detects junk files, duplicate photos, and oversized assets to free up space and improve responsiveness.",
    badge: "Performance & Storage",
    color: "from-amber-50 to-orange-50",
    accent: "bg-amber-100",
    accentText: "text-amber-700",
    icon: "ri-speed-up-line",
    iconColor: "text-amber-600",
    image: "https://readdy.ai/api/search-image?query=iOS%20Cleaner%20app%20interface%20mockup%20on%20iPhone%20showing%20storage%20optimization%20dashboard%20clean%20minimalist%20UI%20orange%20accent%20warm%20tones%20simple%20product%20screenshot%20on%20white%20background&width=400&height=600&seq=fusa-cleaner-product-01&orientation=portrait",
    highlights: ["Smart Junk Detection", "Duplicate Photo Cleaner", "Real-Time Performance"],
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full bg-stone-50 py-24 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16 gap-6">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-stone-400 uppercase mb-3">
              Our Products
            </p>
            <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight tracking-tight">
              Flagship iOS
              <br />
              <em className="not-italic text-stone-500">Applications</em>
            </h2>
          </div>
          <p className="text-stone-500 text-base max-w-sm leading-relaxed lg:text-right">
            Two powerful tools built for real-world iOS users who demand performance, privacy, and simplicity.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.name}
              className={`rounded-3xl bg-gradient-to-br ${product.color} overflow-hidden flex flex-col`}
            >
              {/* Image area */}
              <div className="relative h-72 md:h-96 overflow-hidden flex items-end justify-center pt-8 px-8">
                <img
                  src={product.image}
                  alt={product.name}
                  className="h-full max-w-[200px] object-contain object-top drop-shadow-xl"
                />
              </div>

              {/* Info area */}
              <div className="bg-white/80 backdrop-blur-sm p-8 flex-1">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <span className={`text-xs font-semibold ${product.accentText} ${product.accent} px-3 py-1 rounded-full`}>
                      {product.badge}
                    </span>
                    <h3 className="text-2xl font-extrabold text-gray-900 mt-3 mb-1">{product.name}</h3>
                    <p className="text-sm font-medium text-stone-500">{product.tagline}</p>
                  </div>
                  <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-white shadow-sm">
                    <i className={`${product.icon} ${product.iconColor} text-2xl`} />
                  </div>
                </div>
                <p className="text-stone-600 text-sm leading-relaxed mb-6">{product.description}</p>
                <div className="flex flex-wrap gap-2">
                  {product.highlights.map((h) => (
                    <span key={h} className="text-xs font-medium text-stone-600 border border-stone-200 bg-white rounded-full px-3 py-1 whitespace-nowrap">
                      {h}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
